'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mousetrap = require('mousetrap');

var _mousetrap2 = _interopRequireDefault(_mousetrap);

var _keyConstants = require('../../utils/keyboard/keyConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalKeyboardManager = function (_React$Component) {
    _inherits(ModalKeyboardManager, _React$Component);

    function ModalKeyboardManager() {
        _classCallCheck(this, ModalKeyboardManager);

        return _possibleConstructorReturn(this, (ModalKeyboardManager.__proto__ || Object.getPrototypeOf(ModalKeyboardManager)).apply(this, arguments));
    }

    _createClass(ModalKeyboardManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var close = this.props.close;


            if (close) (0, _mousetrap2.default)(document.body).bind(_keyConstants.SHORTCUT_KEYS.ESCAPE, function (event) {
                return close();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var close = this.props.close;


            if (close) _mousetrap2.default.unbind(_keyConstants.SHORTCUT_KEYS.ESCAPE);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ModalKeyboardManager;
}(_react2.default.Component);

ModalKeyboardManager.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    close: _propTypes2.default.func
};

exports.default = ModalKeyboardManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/ModalKeyboardManager.js
// module id = 1916
// module chunks = 0